module.exports = __webpack_public_path__ + "static/media/green_rectangle.6172e860.svg";